import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { TR } from "@/i18n";

const LangCtx = createContext(null);

function detect() {
  const saved = localStorage.getItem("lang");
  if (saved === "en" || saved === "de") return saved;
  const nav = (navigator.language || "en").toLowerCase();
  return nav.startsWith("de") ? "de" : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l, persist = true) => {
    if (l !== "en" && l !== "de") l = "en";
    setLangState(l);
    localStorage.setItem("lang", l);
    if (persist) api.post("/auth/preferences", { language: l }).catch(() => {});
  }, []);

  const t = useCallback(
    (key) => (TR[lang] && TR[lang][key]) ?? TR.en[key] ?? key,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
